export const lightTheme = {
    body:"hsl(0, 0%, 96%)",
    text:"hsl(209, 23%, 22%)",
    inputColor: "hsl(209, 23%, 22%)",
    inputBackground:"hsl(0, 0%, 100%)",
    element:" hsl(0, 0%, 100%)", 
    buttonColor:"hsl(209, 23%, 22%)"
}

export const darkTheme = {
    body:" hsl(207, 26%, 17%)",
    text:"hsl(0, 0%, 100%)",
    background:"hsl(207, 26%, 17%)",
    inputColor: "hsl(0, 0%, 100%)",
    inputBackground:"hsl(209, 23%, 22%)",
    element:" hsl(209, 23%, 22%)",
    buttonColor:"hsl(0, 0%, 100%)"

    
}